import { render, staticRenderFns } from "./loadingOrderRecordAction.vue?vue&type=template&id=13ce90ca&scoped=true"
import script from "./loadingOrderRecordAction.vue?vue&type=script&lang=js"
export * from "./loadingOrderRecordAction.vue?vue&type=script&lang=js"
import style0 from "./loadingOrderRecordAction.vue?vue&type=style&index=0&id=13ce90ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ce90ca",
  null
  
)

export default component.exports